import styled from "styled-components"

/* Same corner marks as the hero, mirrored in sky blue on the dark surface */
export const Frame = styled.div`
  position: relative;
  max-width: 780px;
  padding: 1.5rem 1.5rem 2rem 1.25rem;
  @media (min-width: 992px) {
    padding: 2.5rem 3rem 3rem 2.25rem;
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 36px;
    height: 36px;
    border: 3px solid var(--sky);
    @media (min-width: 992px) {
      width: 56px;
      height: 56px;
      border-width: 4px;
    }
  }
  &::before {
    top: 0;
    right: 0;
    border-left: 0;
    border-bottom: 0;
  }
  &::after {
    bottom: 0;
    left: 0;
    border-right: 0;
    border-top: 0;
  }
  h2 {
    margin-bottom: 0.75rem;
    max-width: 18ch;
  }
`

export const Lead = styled.p`
  max-width: 52ch;
  margin-bottom: 2rem;
  font-size: 1.1875rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.82);
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 2.25rem;
  > a {
    flex: 1 1 auto;
  }
  @media (min-width: 420px) {
    > a {
      flex: 0 0 auto;
      min-width: 200px;
    }
  }
`

export const Direct = styled.p`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0 0 1.5rem;
  a {
    color: #fff;
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 1.5rem;
    letter-spacing: -0.01em;
    text-decoration: none;
    overflow-wrap: anywhere;
    &:hover {
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-underline-offset: 0.15em;
    }
  }
  @media (min-width: 576px) {
    flex-direction: row;
    gap: 2.5rem;
    a {
      font-size: 1.75rem;
    }
  }
`

export const Notes = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1.75rem;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.72);
  li {
    margin: 0;
  }
  a {
    color: #fff;
  }
`
